export default __webpack_public_path__ + "static/media/tunggu.49cbb87f.svg";